import { cn } from "@app/lib/utils";
import { linksDrawerAtom, searchDrawerAtom } from "@design-system/atoms";
import { useChangeLocaleCode } from "@design-system/hooks";
import { ColoredGlobeIcon, GlobeIcon } from "@design-system/icons";

export function ChangeLanguageButton() {
  const { changeLanguage } = useChangeLocaleCode();

  const [searchDrawerAtomOpened, linksDrawerAtomOpened] = [
    searchDrawerAtom.useOpened(),
    linksDrawerAtom.useOpened(),
  ];

  return (
    <button
      onClick={changeLanguage}
      className={cn(
        "hidden rounded-[4.7rem] border border-transparent bg-white/5 p-3 lg:flex",
        searchDrawerAtomOpened || linksDrawerAtomOpened
          ? "bg-rich-blue !bg-opacity-5"
          : "",
      )}
    >
      {searchDrawerAtomOpened || linksDrawerAtomOpened ? (
        <ColoredGlobeIcon className="h-8 w-8 max-xl:h-5 max-xl:w-5" />
      ) : (
        <GlobeIcon />
      )}
    </button>
  );
}
